import { Injectable } from '@angular/core';
import { DolbyModeResponse } from 'src/app/data-models/audio/dolby-mode-response';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { CommonService } from '../../../common/common.service';
import { AudioService } from '../../audio.service';

@Injectable({
	providedIn: 'root',
})
export class AudioSmartSettingsCapabilityService {
	constructor(
		private commonService: CommonService,
		private audioService: AudioService,
	) {}

	public async get(): Promise<boolean> {
		const cache = await this.getCache();
		if (cache !== undefined) {
			return cache;
		}

		return this.getAudioCapability();
	}

	private getCache(): boolean {
		return this.commonService.getLocalStorageValue(LocalStorageKey.IsDolbyModeAvailable, undefined);
	}

	private async getAudioCapability() {
		const dolbyMode = await this.audioService.getDolbyMode();
		return dolbyMode.available;
	}
}
